import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    // Fire-and-forget; errors are caught internally so this cannot crash the app.
    initPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}